/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {KTSVG} from '../../../_metronic/helpers'
import useUtils from './useUtils'
import {useDispatch, useSelector} from 'react-redux'
import {setTitle} from '../../redux/reducers/mainSlice'
import EditLanguage from './EditLanguage'
import TableSkeleton from '../../modules/skeleton/TableSkelton'
import Pagination from '../../modules/pagination/Pagination'
import DeleteConfirmation from '../../modules/alert/DeleteConfirmation'
import { showAlert } from '../../redux/reducers/alertSlice'
import AssignConfirmation from '../../modules/alert/AssignConfirmation'
import { set } from 'date-fns'

const LanguageList = ({className}) => {
  const {fetchLanguages, deleteLanguage, makeDefault} = useUtils()
  const [show, setShow] = useState(false)
  const [editable, setEditable] = useState({})
  const [loading, setLoading] = useState(true)
  const [languages, setLanguages] = useState()
  const count = languages?.count

  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [totalPages, setTotalPages] = useState(1)

  const [modalVisible, setModalVisible] = useState(false)
  const [assignVisible, setAssignVisible] = useState(false)
  const [selectedId, setSelectedId] = useState(null)
  const [selectedLanguage, setSelectedLanguage] = useState(null)

  const navigate = useNavigate()
  const dispatch = useDispatch()
  dispatch(setTitle('Language'))

  const getLanguages = async () => {
    try {
      setLoading(true)
      const offset = (page - 1) * limit
      const result = await fetchLanguages(limit, offset)
      setTotalPages(Math.ceil(result?.count / limit))
      setLanguages(result)
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  const handleAssign = async (values) => {
    if (values?.isDefault) {
      dispatch(
        showAlert({
          message: `${values?.name} is already default language`,
          variant: 'info',
          timeout: '1500',
        })
      )
      return
    }else{
      setSelectedLanguage(values)
      setAssignVisible(true)
    }
  }

  const confirmAssign = async () => {
    if (!selectedLanguage) return
    try {
      setLoading(true)
      const result = await makeDefault(selectedLanguage, limit, (page - 1) * limit)
      setLanguages(result)
    } catch (error) {
      console.error('Error assigning language:', error)
    } finally {
      setLoading(false)
      setAssignVisible(false)
      setSelectedLanguage(null)
    }
  }


  useEffect(() => {
    getLanguages()
  }, [limit, page])

  const handleDelete = (value) => {
    if (value?.isDefault) {
      dispatch(
        showAlert({
          message: `Default Language cannot be deleted`,
          variant: 'danger',
          timeout: '1500',
        })
      )
    } else {
      setSelectedId(value?.id)
      setModalVisible(true)
    }
  }

  const confirmDelete = async () => {
    if (!selectedId) return
    try {
      setLoading(true)
      const result = await deleteLanguage(selectedId, limit, (page - 1) * limit)
      setLanguages(result)
    } catch (error) {
      console.error('Error deleting Announcement type:', error)
    } finally {
      setLoading(false)
      setModalVisible(false)
      setSelectedId(null)
    }
  }

  if (loading) return <TableSkeleton />
  return (
    <>
      <div className={`card ${className}`}>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
          <div className='d-flex align-items-center gap-10'>
            <h3 className='card-title align-items-start'>
              {/* <span className='card-label fw-bold fs-3 mb-1'>Units List</span> */}
              <span className=' mt-1 text-muted fs-7 '>{count} Items</span>
            </h3>

            {/* begin::Search */}
          </div>
          <div className='card-toolbar'>
            <a
              onClick={() => navigate('/languagelist/addlanguage')}
              className='btn btn-sm btn-light-primary'
            >
              <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
              Add Language
            </a>
          </div>
        </div>
        {/* end::Header */}
        {/* begin::Body */}
        <div className='card-body py-10'>
          {/* begin::Table container */}
          <div className='table-responsive row justify-content-center'>
            {/* begin::Table */}
            <div className='col-lg-12'>
              <table className='table table-row-bordered table-row-gray-100 align-middle  gs-0 gy-3'>
                {/* begin::Table head */}
                <thead>
                  <tr className='fw-bold text-muted'>
                    <th className='w-200px'>ID</th>
                    <th className='w-200px'>Name</th>
                    <th className='w-200px'>Code</th>
                    <th className='min-w-100px text-end'>ACTIONS</th>
                  </tr>
                </thead>
                {/* end::Table head */}
                {/* begin::Table body */}
                <tbody>
                  {languages?.records &&
                    languages?.records?.map((value, index) => {
                      return (
                        <tr key={index}>
                          <td className='text-nowrap'>
                            <a href='#' className='text-dark fw-bold fs-6'>
                              {value.id}
                            </a>
                          </td>
                          <td>
                            <a href='#' className='text-dark fw-bold  fs-6'>
                            {`${value.name} ${value?.isDefault ? '(default)' : ''}`}
                            </a>
                          </td>
                          <td>
                            <a
                              href='#'
                              className='text-dark fw-bold  d-block mb-1 fs-6'
                            >
                              {value?.code}
                            </a>
                          </td>
                          <td className='text-end'>
                            <a
                              onClick={() => {
                                setShow(true)
                                setEditable(value)
                              }}
                              href='#'
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            >
                              <KTSVG
                                path='/media/icons/duotune/art/art005.svg'
                                className='svg-icon-3 svg-icon-primary'
                              />
                            </a>
                            <a
                              onClick={() => handleAssign(value)}
                              className='btn btn-icon btn-bg-light  btn-sm me-1'
                            >
                              <KTSVG
                                path='/media/icons/duotune/general/gen048.svg'
                                className={`svg-icon-3 ${
                                  value?.isDefault ? 'svg-icon-primary' : ''
                                }`}
                              />
                            </a>
                            <a
                              onClick={() => handleDelete(value)}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                            >
                              <KTSVG
                                path='/media/icons/duotune/general/gen027.svg'
                                className='svg-icon-3 text-danger'
                              />
                            </a>
                          </td>
                        </tr>
                      )
                    })}
                </tbody>
                {/* end::Table body */}
              </table>
            </div>
            {/* end::Table */}
          </div>
          {/* end::Table container */}
        </div>
        <div className='d-flex align-items-center justify-content-between pb-5 ps-10 pe-5'>
          <div className='d-flex align-items-center gap-3'>
            <span className='fs-6 text-muted'>Show</span>
            <div>
              <select
                defaultValue={limit}
                className='form-select form-select-solid text-muted select2-hidden-accessible'
                onChange={(e) => {
                  setPage(1)
                  setLimit(e.target.value)
                }}
              >
                <option>10</option>
                <option>20</option>
                <option>50</option>
                <option>100</option>
              </select>
            </div>
          </div>
          <DeleteConfirmation
            isVisible={modalVisible}
            message='Are you sure you want to delete Language?'
            onConfirm={confirmDelete}
            onCancel={() => setModalVisible(false)}
          />
          <AssignConfirmation
            isVisible={assignVisible}
            message='Are you sure you want to change default Language?'
            onConfirm={confirmAssign}
            onCancel={() => setAssignVisible(false)}
          />
          <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} />
        </div>
        {/* begin::Body */}
      </div>
      <EditLanguage
        show={show}
        setLanguages={setLanguages}
        handleClose={() => setShow(false)}
        language={editable}
        limit={limit}
        offset={(page - 1) * limit}
      />
    </>
  )
}

export default LanguageList
